import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import api from '../utils/api';

const Results = () => {
  const { user } = useAuth();
  const [results, setResults] = useState('');
  const [sheetsLink, setSheetsLink] = useState('');
  const [isEditing, setIsEditing] = useState(false);
  const [editText, setEditText] = useState('');
  const [editLink, setEditLink] = useState('');
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    fetchResults();
  }, []);

  const fetchResults = async () => {
    try {
      const response = await api.get('/results');
      setResults(response.data.content || '');
      setSheetsLink(response.data.sheets_link || '');
      setIsLoading(false);
    } catch (error) {
      console.error('Error fetching results:', error);
      setIsLoading(false);
    }
  };

  const handleEdit = () => {
    setEditText(results);
    setEditLink(sheetsLink);
    setIsEditing(true);
  };

  const handleSave = async () => {
    try {
      await api.post('/results', { 
        content: editText,
        sheets_link: editLink 
      });
      setResults(editText);
      setSheetsLink(editLink);
      setIsEditing(false);
      alert('Results updated successfully!');
    } catch (error) {
      alert('Failed to update results');
    }
  };

  const handleCancel = () => {
    setIsEditing(false);
    setEditText('');
    setEditLink('');
  };

  if (isLoading) {
    return (
      <div className="min-h-screen bg-dark text-white flex items-center justify-center">
        <p>Loading...</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-dark text-white p-6">
      <div className="max-w-4xl mx-auto">
        <div className="flex justify-between items-center mb-6">
          <h1 className="text-3xl font-bold">Contest Results</h1>
          {user?.role === 'admin' && !isEditing && (
            <button
              onClick={handleEdit}
              className="px-4 py-2 bg-primary text-white rounded-lg hover:bg-green-600 transition"
            >
              Edit Results
            </button>
          )}
        </div>

        {isEditing ? (
          <div className="space-y-4">
            <div>
              <label className="block text-gray-300 mb-2">Results Content</label>
              <textarea
                value={editText}
                onChange={(e) => setEditText(e.target.value)}
                className="w-full h-64 bg-dark-secondary text-white p-4 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
                placeholder="Enter contest results here..."
              />
            </div>

            <div>
              <label className="block text-gray-300 mb-2">Google Sheets Link (Optional)</label>
              <input
                type="url"
                value={editLink}
                onChange={(e) => setEditLink(e.target.value)}
                className="w-full bg-dark-secondary text-white px-4 py-3 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
                placeholder="https://docs.google.com/spreadsheets/d/..."
              />
            </div>

            <div className="flex gap-3">
              <button
                onClick={handleSave}
                className="px-6 py-2 bg-primary text-white rounded-lg hover:bg-green-600 transition"
              >
                Save
              </button>
              <button
                onClick={handleCancel}
                className="px-6 py-2 bg-dark-secondary text-white rounded-lg hover:bg-gray-700 transition"
              >
                Cancel
              </button>
            </div>
          </div>
        ) : (
          <div>
            {sheetsLink && (
              <div className="mb-6">
                <a
                  href={sheetsLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center px-6 py-3 bg-primary text-white rounded-lg hover:bg-green-600 transition font-semibold"
                >
                  📊 View Results in Google Sheets
                </a>
              </div>
            )}

            <div className="bg-dark-secondary rounded-lg p-6">
              {results ? (
                <pre className="whitespace-pre-wrap text-gray-300 font-sans">
                  {results}
                </pre>
              ) : (
                <p className="text-gray-400 italic">No results have been posted yet.</p>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Results;
